<template>
  <div
    class="active-list-container dzclubs-all-wrap"
    :style="{ height: list.data.length > 0 ? 'auto' : '100%' }"
  >
    <template v-if="list.data.length > 0">
      <div
        class="list-items"
        v-for="item in list.data"
        :key="item.aid"
        :style="{ width: $route.name === 'Active' ? '96%' : '100%' }"
      >
        <router-link :to="{ name: 'ActiveDetail', params: { aid: item.aid } }">
          <el-card
            style="max-width: 480px"
            header-class="list-card-header"
            body-class="list-card-body"
          >
            <template #header>
              <el-image :src="'https://clubs.xinmin.cn/' + item.cover">
                <template #placeholder>
                  <div class="image-slot">加载中...</div>
                </template>
                <template #error>
                  <div class="image-slot image-error-slot">
                    <img src="@/assets/author.png" alt="" />
                  </div>
                </template>
              </el-image>
            </template>
            <div class="card-content">
              <div class="title-container">
                <el-text class="list-title" tag="b" line-clamp="1">{{
                  item.title
                }}</el-text>
                <ActiveListTag :tags="item.regist_status" />
              </div>
              <div class="content-container">
                <KyIcon
                  type="location"
                  color="#ff655f"
                  class="active-icon-container"
                >
                </KyIcon>
                <el-text truncated class="list-address">
                  {{ item.address }}
                </el-text>
              </div>
              <div class="content-container">
                <KyIcon
                  type="dateTime"
                  color="#ff655f"
                  class="active-icon-container"
                >
                </KyIcon>
                <el-text class="list-time">
                  {{ formatDate(item.active_begin_time) }}
                </el-text>
              </div>
              <div
                class="list-status-container"
                v-if="item.regist_status < 3 && item.regist_status != 0"
              >
                <KyIcon
                  type="userinfo"
                  color="#ff655f"
                  class="active-icon-container"
                >
                </KyIcon>
                <el-text class="list-status">
                  {{
                    item.number === item.total
                      ? "报名人数已满"
                      : item.number + "人已报名"
                  }}
                </el-text>
              </div>
            </div>
          </el-card>
        </router-link>
      </div>
    </template>
    <Empty text="暂时没有活动数据" v-else></Empty>
  </div>
</template>
<script>
import { percentage, formatDate } from "@/utils";
import KyIcon from "@/components/KyIcon";
import ActiveListTag from "./ActiveListTag";
import Empty from "@/components/Empty";
export default {
  components: {
    ActiveListTag,
    KyIcon,
    Empty,
  },
  props: {
    list: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    percentage,
    formatDate,
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/mixin.less";
.dzclubs-all-wrap {
  background-color: transparent;
  padding-top: 10px;
  .list-items {
    background-color: var(--fff);
    margin: 20px auto;
    border-radius: 8px;
    &:first-child {
      margin: 0 auto 20px;
    }
    &:last-child {
      margin: 20px auto 0;
    }
    .card-content {
      .self-flex(flex-start);
      flex-direction: column;
      gap: 5px;
      .title-container {
        .self-flex(space-between);
        align-items: center;
        margin-bottom: 5px;
      }
      .list-title {
        flex: 1;
        font-size: 16px;
        color: #0d0d0d;
        text-align: left;
      }
      .content-container {
        .self-flex(flex-start);
        align-items: center;
        color: #3e3e3e;
      }
      .list-status-container {
        .self-flex(flex-start);
      }
    }
    .list-layout-container {
      padding: 10px 0;
      margin: auto;
      width: 96%;
    }
  }
  .active-icon-container {
    .active-icon(15px);
    margin-right: 10px;
    flex: 0 0 auto;
  }
  .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: var(--el-fill-color-light);
    color: var(--el-text-color-secondary);
    font-size: 16px;
  }

  .image-error-slot {
    width: 100%;
    height: 200px;
    img {
      width: 40%;
    }
  }
}
</style>